import { render } from "./ConfigurationRestorePointDrawer.vue?vue&type=template&id=c2899830&scoped=true"
import script from "./ConfigurationRestorePointDrawer.vue?vue&type=script&lang=js"
export * from "./ConfigurationRestorePointDrawer.vue?vue&type=script&lang=js"

import "./ConfigurationRestorePointDrawer.vue?vue&type=style&index=0&id=c2899830&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2899830"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QBtn,QDrawer,QIcon});
